<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <!-- boton crear -->
    <v-row class="" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex justify-end gap-10px">
        <TableButtonComp @click="addItem" normalButton textButton="Crear Comunicados" iconBut="fas fa-plus"
          class="mt-2 mb-4" />

        <TableButtonComp @click="dialogdelete = true" normalButton textButton="Eliminar" iconBut="fas fa-trash-alt"
          class="mt-2 mb-4" classColor="red" :disabled="!selected.length" />

        <ComunDialogComp v-model="dialogdelete" Deletedialog @close-modal="dialogdelete = false"
          @delete-item="deleteComunicados" @cancel-item="dialogdelete = false" deleteComunicados
          titleWindow="Eliminar comunicado">
          <template v-slot:body>
            <div>
              <span v-if="selected.length > 1">
                ¿Está seguro de eliminar estos registros?
              </span>
              <span v-else>
                ¿Está seguro de eliminar este registro?
              </span>
            </div>
          </template>
        </ComunDialogComp>
      </v-col>
    </v-row>

    <!-- consultar -->

    <ComundataTablecomp whitSearch whitSelect placeholderTextsearch="Buscar comunicado" v-model="selected"
      :headers="ConfigInicioheaders" noResultsText="Sin comunicados" :items="data">
      <!-- Si es VIDEO -->
      <template v-slot:filename="{ item }">
        <template v-if="checkExtension(item.nombre_original)">
          <video width="250" height="170" controls>
            <source :src="item.uri ? baseUrlS3 + item.uri : 'Video no encontrado'" type="video/mp4">
            Tu navegador no soporta videos.
          </video>
        </template>
        <!-- Si es IMAGEN -->
        <template v-else>
          <!-- <v-tooltip bottom> -->
          <!-- <template v-slot:activator="{ on, attrs }"> -->
          <!-- <v-chip dense v-bind="attrs" v-on="on">
                <v-icon left small>
                  {{
                    item.filename ? "fas fa-image" : "fas fa-exclamation-circle"
                  }}
                </v-icon>
                {{ item.filename ? item.filename : "Sin Imagen" }}
              </v-chip> -->
          <!-- </template> -->
          <img :src="item.uri ? baseUrlS3 + item.uri : ' Imagen no encontrada'"
            :alt="item.uri || ' Imagen no encontrada'" width="250" height="170" />
          <!-- </v-tooltip> -->
        </template>
      </template>

      <template v-slot:activo="{ item }">
        <v-chip :class="item.activo ? 'color_activo' : 'color_inactivo'" @click="editEstatus(item)" small>{{ item.activo
          ?
          "Activo" : "Inactivo" }}</v-chip>
      </template>

      <template v-slot:destinatario="{ item }">
        <span>{{
          item.perfil == null ? "Todos" : item.perfil.descripcion_perfil
        }}</span>
      </template>

      <template v-slot:fecha_inicio="{ item }">
        <span>{{ formatFec(item.fecha_inicio) }}</span>
      </template>

      <template v-slot:fecha_fin="{ item }">
        <span>{{ formatFec(item.fecha_fin) }}</span>
      </template>

      <template v-slot:action_editar="{ item }">
        <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
          tooltipText="Editar comunicado" />
      </template>
    </ComundataTablecomp>

    <!-- MODAL CREAR -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog" :evento="evento" @close-modal="closeModal"
        :title="evento === 'agregar' ? 'Crear comunicado' : 'Editar comunicado'" maxWidth="1200">
        <template v-slot:body>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense class="text-center" color="primary" dark>
                <h3>Datos del comunicado</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="py-0">
              <template>
                <v-select v-model="perfilesSeleccionados" :items="listPerfiles" item-value="id"
                  item-text="descripcion_perfil" label="Destino del comunicado" :disabled="evento === 'editar'" multiple
                  outlined dense :rules="validationRules.ValidateDestino">
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggle">
                      <v-list-item-action>
                        <v-icon :color="perfilesSeleccionados.length > 0
                          ? 'indigo darken-4'
                          : ''
                          ">
                          {{ iconSelected }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title> Todos </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </template>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Nivel" v-model="comunicado.id_nivel" :items="listNiveles" item-value="id"
                item-text="desc_nivel" :rules="validationRules.validateNivel"
                @change="getGrados(comunicado.id_nivel)" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Grado" v-model="comunicado.id_grado" :items="listGrados" item-value="id"
                item-text="desc_grado" :rules="validationRules.validateGrado"
                @change="getSecciones(comunicado.id_grado)" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Sección" v-model="comunicado.id_seccion" :items="listSecciones"
                item-value="id" item-text="nombre_seccion" :rules="validationRules.validateSeccion" />
            </v-col>

            <v-col cols="12" md="3" sm="6" xs="12" class="py-0">
              <v-file-input v-model="archivoSubir" accept=".jpg, .png, .gif" label="Imagen/Video" outlined
                dense></v-file-input>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
              <v-switch cols="12" md="12" sm="12" xs="12" color="primary" v-model="comunicado.estado_titulo"
                label="¿Desea que se muestre el titulo en el comunicado?"></v-switch>
            </v-col>

            <v-col cols="12" md="6" sm="6" xs="12" class="py-0">
              <textfieldComp textArea textLabel="Título" v-model="comunicado.titulo"
                :rules="[...validationRules.validatetextArea, v => (v && v.trim().length <= 80 && v.trim().length != 0) || 'El título no puede exceder los 80 caracteres']" />
            </v-col>

            <v-col cols="12" md="6" sm="6" xs="12" class="py-0">
              <textfieldComp textArea textLabel="Subtítulo" v-model="comunicado.subtitulo"
                :rules="[v => (v.trim().length <= 100) || 'El subtítulo no puede exceder los 100 caracteres']" />
              <div></div>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense class="text-center" color="primary" dark>
                <h3>Contenido del comunicado</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" class="py-0 my-2" justify-center>
              <ckeditor class="d-flex editor justify-center" tag-name="textarea" v-model="comunicado.contenido"
                :config="editorConfig"></ckeditor>
            </v-col>

            <v-col cols="12" xs="12" md="6" class="">
              <v-menu v-model="menuFechaIni" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" label="Fecha de inicio" prepend-icon="mdi-calendar"
                    outlined dense readonly v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="comunicado.fecha_inicio" no-title @input="menuFechaIni = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="6" class="">
              <v-menu v-model="menuFechaFin" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted4" label="Fecha de término" outlined dense
                    prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="comunicado.fecha_fin" no-title @input="menuFechaFin = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp @click="saveModal()" :loading="isPending" normalButton iconBut="fas fa-save"
            :textButton="evento == 'agregar' ? 'Guardar' : 'Guardar cambios'">
          </TableButtonComp>
        </template>
      </ComunDialogComp>
    </v-form>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import ComundataTablecomp from "@/components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "@/components/ComponentsEst/TableButtonComp.vue";
import ComunDialogComp from "@/components/ComponentsEst/ComunDialogComp.vue";
import textfieldComp from "../../../../components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
// import fileinputComp from "../../../../components/ComponentsEst/fileinputComp.vue";
// import inputDateCompVue from "../../../../components/ComponentsEst/inputDateComp.vue";
import { ConfigInicioheaders } from "@/helpers/headersTable.js";
import { validationRules } from "@/helpers/validatorHelpers.js";
import { mapMutations, mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "configuracionComunicado",

  components: {
    ComundataTablecomp,
    TableButtonComp,
    ComunDialogComp,
    AutocompleteComp,
    textfieldComp,
    // inputDateCompVue,
    // fileinputComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    rutaservidor: API_URL,
    rutaS3: BUCKET_ORIGIN_SPACE,
    ConfigInicioheaders,
    paramComponente: {
      id_submodulo: 143,
      id_modulo: 3,
    }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario

    selected: [],
    data: [],

    dialog: false,
    dialogdelete: false,
    evento: "agregar",

    menuFechaIni: false,
    menuFechaFin: false,

    listPerfiles: [],
    perfilesSeleccionados: [], // lista de ids seleccionados
    isPending: false, //Para el formulario
    listNiveles: [],
    listGrados: [],
    listSecciones: [],
    comunicado: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_perfil: [],
      id_nivel: null,
      id_grado: null,
      id_seccion: null,
      titulo: "",
      subtítulo: "",
      contenido: "",
      fecha_inicio: "",
      fecha_fin: "",
      estado_titulo: false,
    },
    archivoSubir: null,

    // EDITOR CONTENIDO COMUNICADO
    //
    editorConfig: {
      extraPlugins: "language,font,image",
      toolbar: [
        "Format",
        ["Bold", "Italic", "Strike", "Underline"],
        ["BulletedList", "NumberedList", "Blockquote"],
        ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
        ["Link", "Unlink"],
        ["FontSize", "TextColor"],
        ["Image"],
        ["Undo", "Redo"],
        ["Source", "Maximize"],
      ],
      height: "200",
      width: "95%",
      toolbarCanCollapse: true,
      allowedContent: true,
      // uiColor: "#01579b",
      codeSnippet_theme: "pojoaque",
      filebrowserImageBrowseLinkUrl:
        "https://onedrive.live.com/?id=59FFBD6D7046F78D%21105&cid=59FFBD6D7046F78D",
      font_names:
        "Arial/Arial, Helvetica, sans-serif;" +
        "Times New Roman/Times New Roman, Times, serif;" +
        "Verdana",

      codeSnippet_languages: {
        javascript: "JavaScript",
        php: "PHP",
      },
    },
  }),

  //computadas
  computed: {
    // validaciones
    validationRules() {
      return validationRules;
    },

    ...mapGetters("login", ["componenteEvento"]),

    computedDateFormatted() {
      return this.comunicado.fecha_inicio
        ? moment(this.comunicado.fecha_inicio).format("DD/MM/YYYY")
        : "";
    },

    baseUrlS3() {
      return this.rutaS3 + "/"
    },

    computedDateFormatted4() {
      return this.comunicado.fecha_fin
        ? moment(this.comunicado.fecha_fin).format("DD/MM/YYYY")
        : "";
    },

    selectAllPerfiles() {
      return this.perfilesSeleccionados.length === this.listPerfiles.length;
    },
    selectSomePerfiles() {
      return this.perfilesSeleccionados.length > 0 && !this.selectAllPerfiles;
    },
    iconSelected() {
      if (this.selectAllPerfiles) return "mdi-close-box";
      if (this.selectSomePerfiles) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  mounted() {
    this.loadMain();
    this.addClaseSecondary();
  },

  updated() {
    this.addClaseSecondary();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    //-- cargar Parametros de inicio del componente --
    async loadMain() {
      this.limpiarForm();
      this.getPerfiles();
      this.getNiveles();
      this.getComunicados();
    },

    checkExtension(nombre) {
      if (!nombre) return false; // Retorna false si filename no está definido
      // expresión regular que busca las extensiones al final del nombre del archivo
      const regex = /\.(mp4|mov|avi|mkv)$/;
      // Retorna true si encuentra alguna de las extensiones, false en caso contrario
      return regex.test(nombre);
    },

    async getComunicados() {
      try {
        let response = await axios.get(
          `/inicio/comunicados/${sessionStorage.id_colegio}`
        );
        this.data = response.data;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });
      }
    },

    async deleteComunicados() {
      try {
        if (!this.selected.length) {
          //Si no hay ninguno seleccionado
          this.setEnviarMens({
            tipo: "E",
            mensaje: "Seleccione al menos un comunicado para eliminar",
            tiempo: null,
          });
          return;
        }

        let idsComunicados = this.selected.map((c) => c.id);
        let response = await axios.post(`/inicio/comunicados/deleteMasive/`, {
          comunicados: idsComunicados,
        });

        if (response.data.messageT === "S") {
          this.setEnviarMens({
            tipo: "S",
            mensaje: response.data.message,
            tiempo: null,
          });
          this.selected.splice(0); //Vaciar selected
          this.getComunicados();
          this.dialogdelete = false;
        } else if (response.data.messageT === "E") {
          this.setEnviarMens({
            tipo: "E",
            mensaje: response.data.message,
            tiempo: null,
          });
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });
      }
    },

    limpiarForm() {
      (this.comunicado = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_perfil: null,
        id_nivel: null,
        id_grado: null,
        id_seccion: null,
        titulo: "",
        subtitulo: "",
        contenido: "",
        fecha_inicio: "",
        fecha_fin: "",
        estado_titulo: false,
      }),
        (this.archivoSubir = null);
      this.resetValidation();
    },

    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    async editEstatus(item) {
      try {
        const estatus = !item.activo;
        let res = await axios.put(`/inicio/comunicados/${item.id}/`, {
          activo: estatus,
        });

        if (res.data.messageT == "S") {
          item.activo = estatus;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });
      }
    },

    addItem() {
      this.limpiarForm();
      this.evento = "agregar";
      this.dialog = true;
    },

    async editItem(item) {
      this.evento = "editar";
      this.comunicado = item;
      this.perfilesSeleccionados.splice(0);
      this.perfilesSeleccionados.push(item.id_perfil);
      this.getGrados(item.id_nivel);
      this.getSecciones(item.id_grado);
      this.dialog = true;
    },

    closeModal() {
      this.limpiarForm();
      this.dialog = false;
    },

    async saveModal() {
      if (this.$refs.formDatos.validate()) {
        try {
          const { fecha_inicio, fecha_fin } = this.comunicado;
          this.isPending = true;
          const fechaActual = moment().format("YYYY-MM-DD"); // Obtener la fecha actual
          const fechaInicio = moment(fecha_inicio);
          const fechaFin = moment(fecha_fin);

          if (
            !fechaInicio.isValid() ||
            !fechaInicio.isValid() ||
            !fechaInicio.isSameOrAfter(fechaActual) ||
            !fechaInicio.isSameOrBefore(fechaFin)
          ) {
            // Condicion, si la fecha no existe o no tiene coherencia
            //mostrar un mensjae de error
            this.setEnviarMens({
              tipo: "W",
              mensaje: `Por favor verifique que las fechas sean correctas`,
              tiempo: 8000,
            });
            return;
          }

          if (
            !this.archivoSubir &&
            this.comunicado.titulo == "" &&
            this.comunicado.contenido == ""
          ) {
            // Condición por si ni se subió imagen ni descripción, almenos uno debe existir
            this.setEnviarMens({
              tipo: "W",
              mensaje: `Por favor, subir un archivo o redactar un comunicado`,
              tiempo: 6000,
            });
            return;
          }

          let formData = new FormData();
          formData.append("id_usuario", sessionStorage.id);
          if (this.archivoSubir) formData.append("subirArchivo", this.archivoSubir);

          const keys = Object.keys(this.comunicado);
          for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (key != "id" && key != "perfil" && key != "id_perfil")
              formData.append(key, this.comunicado[key]);
          }

          // SE CAMBIÓ LA LÓGICA POR UN FEATURE (OP: #1050 ) para enviar multiples comunicados a la vez
          let araryPromesas = [];
          let res;

          if (this.perfilesSeleccionados.length === 0) {
            this.setEnviarMens({
              tipo: "W",
              mensaje: "Por favor, elija un destinatario",
              tiempo: null,
            });
            return;
          } else if (this.evento === "agregar") {
            // Si seleccionó todos podemos hacer un array de promesas para hacer varios post

            this.perfilesSeleccionados.forEach((id_perfil) => {
              const formDataCopia = this.cloneFormData(formData);
              // se actualiza la propiedad id_perfil para cada peticion
              formDataCopia.append("id_perfil", id_perfil);
              // y se añade las peticiones del array
              araryPromesas.push(
                axios.post("/inicio/comunicados/", formDataCopia, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
              );
            });
          } else if (this.evento === "editar") {
            let id_perfil = this.perfilesSeleccionados[0];
            const formDataCopia = this.cloneFormData(formData);
            formDataCopia.append("id_perfil", id_perfil);
            araryPromesas.push(
              axios.put(
                `/inicio/comunicados/${this.comunicado.id}/`,
                formDataCopia,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              )
            );
          }

          // SE ESPERA UNA RESPUESTA
          const responses = await Promise.all(araryPromesas);
          res = responses[0];
          // SE VACIA LA LISTA DE SELECCIONADOS
          this.perfilesSeleccionados.splice(0);
          this.savenotif();
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: null,
          });

          if (res.data.messageT == "S") {
            this.limpiarForm();
            this.dialog = false;
            this.loadMain();
          }
        } catch (error) {

          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error}`,
            tiempo: null,
          });
        } finally {
          this.isPending = false;
        }
      }
    },

    async savenotif() {
      let titulo = ''
      let contenido = ''
      let action = ''
      if (this.evento == 'agregar') {
        titulo = 'Anuncio'
        contenido = 'Se agrego un comunicado para todos los usuarios del colegio' + this.datoLogin.nombre_colegio
        action = 'fas fa-plus-square'
      } else if (this.evento == 'editar') {
        titulo = 'Anuncio'
        contenido = 'Se edito un comunicado para todos los usuarios del colegio' + this.datoLogin.nombre_colegio
        action = 'fas fa-edit'
      }
      const fechaActual = new Date();
      const horaActual = fechaActual.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const datanotif = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        titulo_notif: titulo,
        contenido_notif: contenido,
        id_perfil: this.datoLogin.id_perfil,
        id_usuario: this.datoLogin.id,
        fecha_notif: fechaActual,
        hora_notif: horaActual,
        icon_notif: action,
      };
      try {
        const response1 = await axios.post("/notification/persona/addglobalnotif/", datanotif);
        this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getPerfiles() {
      try {
        let response = await axios.get(
          `/sistema/usuario/getPerfil/colegio/${sessionStorage.id_colegio}`
        );
        this.listPerfiles = response.data;
        // this.listPerfiles.unshift({ id: -1, descripcion_perfil: "Todos" });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });
      }
    },

    async getNiveles() {
      this.comunicado.id_nivel = -1;
      let params = {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio_adm_nivel: sessionStorage.id_colegio,
      };

      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          params
        );
        this.listNiveles = response.data;
        this.listNiveles.unshift({
          id: -1,
          desc_nivel: "Todos",
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });

      }
    },

    async getGrados(idNivel) {
      this.comunicado.id_seccion = -1;
      this.comunicado.id_grado = -1;
      this.listGrados = [];
      this.listSecciones = [];
      if (idNivel != -1) {
        const indexNivel = this.listNiveles.findIndex(
          (nivel) => nivel.id == idNivel
        );
        let params = {
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
          id_nivel: this.listNiveles[indexNivel].id_nivel_adm_nivel,
        };

        try {
          let response = await axios.post(
            "/administrativo/grado/gradosNivelAdmin/",
            params
          );
          this.listGrados = response.data;
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error}`,
            tiempo: null,
          });
        }
      }
      this.listGrados.unshift({
        id: -1,
        desc_grado: "Todos",
      });

      this.listSecciones.unshift({
        id: -1,
        nombre_seccion: "Todos",
      });
    },

    async getSecciones(idGrado) {
      this.comunicado.id_seccion = -1;
      this.listSecciones = [];
      if (idGrado != -1) {
        let params = {
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
          id_grado: idGrado,
        };

        try {
          let response = await axios.post(
            "/administrativo/seccion/seccionGrado/",
            params
          );
          this.listSecciones = response.data;
          this.listSecciones.unshift({
            id: -1,
            nombre_seccion: "Todos",
          });
          if (this.listSecciones.length === 0)
            this.setEnviarMens({
              tipo: "W",
              mensaje: "No existen secciones para este grado",
              tiempo: null,
            });
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error}`,
            tiempo: null,
          });

        }
      } else {
        this.listSecciones.push({
          id: -1,
          nombre_seccion: "Todos",
        });
      }
    },

    formatFec(fecha) {
      return moment(fecha).format("DD/MM/YYYY");
    },

    addClaseSecondary() {
      let ths = document.querySelectorAll("th[role='columnheader']");
      ths.forEach((th) => th.classList.add("secondary"));
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllPerfiles) {
          this.perfilesSeleccionados = [];
        } else {
          this.perfilesSeleccionados = this.listPerfiles
            .map((e) => e.id)
            .slice();
        }
      });
    },

    cloneFormData(formData) {
      const clonedFormData = new FormData();
      for (const pair of formData.entries()) {
        clonedFormData.append(pair[0], pair[1]);
      }
      return clonedFormData;
    },
  },
};
</script>
<style scoped>
.v-chip.v-size--default {
  margin: 2px;
}

/* .editor {
  z-index: 10000 !important;
}

.cke_combopanel {
  z-index: 10002 !important;
} */
</style>